import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "../../models/User";

interface IUserProfileState {
  isAuthorized: boolean | null;
  user: IUser | null;
  roles: string[];
}

const initialState: IUserProfileState = {
  isAuthorized: null,
  user: null,
  roles: [],
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ user: IUser; roles: string[] }>) => {
      state.isAuthorized = true;
      state.user = action.payload.user;
      state.roles = action.payload.roles;
    },
    logout: (state) => {
      state.isAuthorized = false;
      state.user = null;
      state.roles = [];
    },
    updateProfileImage: (state, action: PayloadAction<string>) => {
      if (state.user) {
        state.user.profileImagePath = action.payload;
      }
    },
    updateProfile: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
  },
});

export const { login, logout, updateProfileImage, updateProfile } = userProfileSlice.actions;

export default userProfileSlice.reducer;
